import * as z from 'zod';
import { schema } from '@forms/helpers';
import { getSelectedDays } from './helpers';
import { AddTaskScheduleDays, AddTaskScheduleFormValues } from './types';

export const formSchema = z.object({
  days: z
    .object({
      from: z.date().nullable(),
      to: z.date().nullable(),
      excluded: z.array(z.string()),
    })
    .refine((days: AddTaskScheduleDays) => getSelectedDays(days).length > 0, {
      message: 'addTaskSchedule.days.required',
    }),
  foremanId: z.string(),
  defaultCrew: schema.boolean(),
  defaultEquipment: schema.boolean(),
});

export const defaultValues: AddTaskScheduleFormValues = {
  days: { from: null, to: null, excluded: [] },
  foremanId: '',
  defaultCrew: true,
  defaultEquipment: true,
};
